<template>
  <v-dialog :persistent="true" max-width="600px" v-model="inDialog">
    <v-card>
      <v-form ref="viewPresentForm">
        <div class="headline dialog-header">
          <v-toolbar color="primary" dark>
            <v-toolbar-title style="padding-left: 10px">{{
              $t(formName)
              }}
            </v-toolbar-title>
          </v-toolbar>
          <v-btn
              @click="onCancel"
              icon
              style="position: absolute; right: 10px; top: 10px; color: #fff"
          >
            <v-icon>cancel</v-icon>
          </v-btn>
        </div>

        <v-card-text>
          <v-toolbar color="white" flat>
            <v-toolbar-title>{{$t('lang.groups.userList')}}</v-toolbar-title>
            <v-divider
                class="mx-2"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <c-search-form :displayToolbar="false"
                         :fields="fields"
                         :input-create-items="createItems"
                         :input-search-items="searchItems"
                         :reload="timeReload"
                         :rows-per-page-items="[10,20,50]"
                         :search-url="searchUrl"
                         @onChooseUser="onChooseUser"
                         form-type="intable"
                         key-property="deputyId"
                         ref="searchTable"
          />
          <div style="text-align: right">
            <v-btn @click="onCancel" color="error">
              <v-icon dark left>cancel</v-icon>
              {{ $t("lang.common.cancel") }}
            </v-btn>
          </div>
        </v-card-text>
        <!-- </v-container> -->
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import {message} from "../../../services";
  import axios from "axios";
  import CSearchForm from "../../../components/form/ManageForm";

  export default {
    name: "group-user-list-waiting",
    components: {axios, CSearchForm},
    props: {
      propsItem: {
        type: Object,
        default: null,
      },
      cDialog: {
        type: Boolean,
        default: false,
      },
      rowsPerPageItems: {
        type: [Array, Number],
        default: () => [10, 20, 30, 40, 50]
      },
      timeReload: {
        type: [Number],
        default: 0
      }
    },
    data: () => {
      return {
        formName: "Thêm mới người dùng vào đơn vị",
        item: {
          status: 1,
        },
        inDialog: false,
        searchItems: [],
        createItems: [],
        searchUrl: "",
        fields: [
          {
            value: "index",
            text: "lang.common.index",
            width: "5%",
            sortable: false,
            headerStyle: "text-align:center"
          },

          {
            value: 'fullName',
            text: 'lang.user.fullName',
            width: "20%",
            sortable: false,
            headerStyle: "text-align:left",
            search: true

          },
          {
            value: 'custom_action_list',
            text: "lang.common.actions",
            width: "5%",
            items: [
              {
                text: "lang.common.choose",
                icon: "add",
                event: "onChooseUser",
                color: "primary"
              },

            ],

          },
        ],
      };
    },
    watch: {
      propsItem: {
        handler(value) {
          if (value !== null) {
            this.item = Object.assign({}, value)
            console.log("groupId", this.item['groupId'])
            this.searchUrl = "/groups/userNotInGroup/list/" + this.item['groupId']
          } else {
            this.resetFrom();
          }
        },
        deep: true,
      },
      cDialog(value) {
        this.inDialog = value;
      },
      inDialog(value) {
        if (!value) {
          this.$emit("closeDialog", "");
        }
      },
    },
    methods: {
      resetFrom: function () {
        this.item = {
          status: 1,
        };
      },
      onCancel: function () {
        this.$emit("closeDialog", "");
        this.searchUrl = "";
      },
      onChooseUser(item) {
        item['groupId'] = this.item['groupId'];
        item['status'] = 1
        axios.post(process.env.VUE_APP_API_URL + "/userGroup/save", item).then(
          data => {
            if (data.success) {
              message.success(this.$t("lang.common.update_success"));
              this.timeReload = Math.floor(Math.random() * 100);
            } else {
              message.error(data.description);
            }
          }
        )
      },

    },
    created() {

    },
  };
</script>
